export const INSTRUCTOR_GET_SUCCESS = "INSTRUCTOR_GET_SUCCESS" as const
export const RESET_PROFILE_AUTH = "RESET_PROFILE_AUTH" as const
export const PROFILE_LOADING = "PROFILE_LOADING" as const
export const UPDATE_FIREBASE_PROFILE = "UPDATE_FIREBASE_PROFILE" as const
export const UPDATE_FIREBASE_AUTH = "UPDATE_FIREBASE_AUTH" as const
export const RESET_BOOKING_STATE = "RESET_BOOKING_STATE" as const
export const RESET_AVAILS = "RESET_AVAILS" as const
export const INSTRUCTOR_UPDATE_ADMIN_ID = "INSTRUCTOR_UPDATE_ADMIN_ID" as const
export const UPDATE_LESSON_INSTRUCTOR = "UPDATE_LESSON_INSTRUCTOR" as const
export const UPDATE_PACKAGE_CHOICE = "UPDATE_PACKAGE_CHOICE" as const
export const RESET_PACKAGE_CHOICE = "RESET_PACKAGE_CHOICE" as const
export const SET_TRANSIENT_SLOT_ID = "SET_TRANSIENT_SLOT_ID" as const
export const SLOTS_GET_SUCCESS = "SLOTS_GET_SUCCESS" as const
export const SNACKBAR_SET_MESSAGE = "SNACKBAR_SET_MESSAGE" as const
export const SNACKBAR_CLEAR_MESSAGE = "SNACKBAR_CLEAR_MESSAGE" as const
export const UPDATE_STUDENT = "UPDATE_STUDENT" as const
export const UPDATE_ADMIN_STUDENT = "UPDATE_ADMIN_STUDENT" as const
export const UPDATE_PACKAGE_SELECT_SKIPPED =
  "UPDATE_PACKAGE_SELECT_SKIPPED" as const
export const SET_DAYS_EVENTS = "SET_DAYS_EVENTS" as const
export const RESET_DAYS_EVENTS = "RESET_DAYS_EVENTS" as const
export const LOG_ADD_ERROR = "LOG_ADD_ERROR" as const
export const LOG_ADD_SUCCESS = "LOG_ADD_SUCCESS" as const
export const LOG_ADD_START = "LOG_ADD_START" as const
export const USER_LESSONS_GET_SUCCESS = "USER_LESSONS_GET_SUCCESS" as const
export const UPDATE_VISIT_LOCATION = "UPDATE_VISIT_LOCATION" as const
export const DE_PACKAGE_RESET = "DE_PACKAGE_RESET" as const
export const DE_PACKAGE_SET = "DE_PACKAGE_SET" as const
export const DE_LESSON_PACKAGE_SET = "DE_LESSON_PACKAGE_SET" as const
export const DE_LESSONS_PURCHASED = "DE_LESSONS_PURCHASED" as const
export const SET_REGION_CITIES = "SET_REGION_CITIES" as const
export const UPDATE_USER_OPTION = "UPDATE_USER_OPTION" as const
export const REGION_GET_SUCCESS = "REGION_GET_SUCCESS" as const
export const SET_PACKAGE_PRICES = "SET_PACKAGE_PRICES" as const
export const UPDATE_SEARCH_ADDRESS = "UPDATE_SEARCH_ADDRESS" as const
export const NO_SLOTS_RETURNED = "NO_SLOTS_RETURNED" as const
export const RESET_SEARCH = "RESET_SEARCH" as const
export const UPDATE_SEARCH_CITY = "UPDATE_SEARCH_CITY" as const
export const UPDATE_SEARCH_GEOCODE = "UPDATE_SEARCH_GEOCODE" as const
export const CLEAR_SEARCH_ADDRESS = "CLEAR_SEARCH_ADDRESS" as const
export const RESET_SEARCH_ADDRESS_CLEARED =
  "RESET_SEARCH_ADDRESS_CLEARED" as const
export const SCHEDULE_FETCH_ERROR = "SCHEDULE_FETCH_ERROR" as const
export const OUT_OF_SERVICE_AREA = "OUT_OF_SERVICE_AREA" as const
export const ALERT_BAR_CLOSE = "ALERT_BAR_CLOSE" as const
export const COURSE_SET_TIMER_IS_RUNNING =
  "COURSE_SET_TIMER_IS_RUNNING" as const
export const COURSE_MARK_CHALLENGE_COMPLETE =
  "COURSE_MARK_CHALLENGE_COMPLETE" as const
export const IS_SEARCHING = "SEARCH:IS_SEARCHING" as const
export const SET_DONE_SEARCH = "SEARCH:SET_DONE_SEARCH" as const
export const STOP_SEARCH = "SEARCH:STOP_SEARCH" as const
export const IS_DONE_SEARCHING = "SEARCH:IS_DONE_SEARCHING" as const
export const SET_SEARCH_DATES = "SEARCH:SET_SEARCH_DATES" as const
export const UPDATE_SEARCH_COUNTY = "UPDATE_SEARCH_COUNTY" as const
export const SET_PRICE_BREAKDOWN = "BOOKING:SET_PRICE_BREAKDOWN" as const
export const UPDATE_SEARCH_STATE = "UPDATE_SEARCH_STATE" as const
export const UPDATE_STATE_CONFIG = "UPDATE_STATE_CONFIG" as const
export const UPDATE_SEARCH_ZIPCODE = "UPDATE_SEARCH_ZIPCODE" as const
export const SET_MEETING_POINTS = "SET_MEETING_POINTS" as const
export const SET_SPOT_TAKEN = "SET_SPOT_TAKEN" as const
export const SET_SELECTED_LESSON_TYPE = "SET_SELECTED_LESSON_TYPE" as const
export const SET_INCLUDE_PRIVATE = "SEARCH:INCLUDE_PRIVATE" as const
export const SET_CART_ID = "CART:SET_CART_ID" as const
export const UPDATE_LAST_ACTIVE_UPDATED_AT =
  "UPDATE_LAST_ACTIVE_UPDATED_AT" as const
export const AUTO_APPLY_COUPON = "CART:AUTO_APPLY_COUPON" as const
export const RESET_AUTO_APPLY_COUPON = "CART:RESET_AUTO_APPLY_COUPON" as const

export const RESET_USER_STATE = "RESET_USER_STATE" as const
export const RESET_ADMIN_STATE = "RESET_ADMIN_STATE" as const
export const RESET_INSTRUCTOR_STATE = "RESET_INSTRUCTOR_STATE" as const
export const RESET_CART_STATE = "RESET_CART_STATE" as const
export const RESET_COURSES_STATE = "RESET_COURSES_STATE" as const
export const SET_PREP_TEST_SCORES = "PREP:SET_PREP_TEST_SCORES" as const
